import { RQ } from 'utils';

export default {
  getInfo: async function () {
    let self = this;
    const d = await RQ.mall.get('/api/h5/member/getMemberRank');
    if (d && d.code == 0) {
      console.log(d, d.data, d.data.enterpriseNo);
      self.info = d.data;
    }
  }
};



// WEBPACK FOOTER //
// ./src/module/app/member/action.js